import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import api from '../api';

/**
 * Abertura manual da avaliação pela diretoria (a qualquer momento), com duração escolhida.
 * `reabrir` muda o texto quando a avaliação já foi encerrada.
 */
const AbrirAvaliacaoDialog = ({ open, peladaId, reabrir = false, onClose, onAberta }) => {
  const [horas, setHoras] = useState(24);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const abrir = async () => {
    setEnviando(true);
    setErro('');
    try {
      const response = await api.post(`avaliacoes/${peladaId}/abrir`, { horas });
      onAberta && onAberta(response.data);
    } catch (error) {
      setErro(error.response?.data?.error || 'Não foi possível abrir a avaliação.');
    }
    setEnviando(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{reabrir ? 'Reabrir avaliação' : 'Abrir avaliação agora'}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Os jogadores que fizeram check-in poderão dar de 1 a 5 estrelas para os colegas. Todos recebem uma notificação com o link.
          {reabrir && ' As notas já registradas são mantidas e o resultado é recalculado no novo encerramento.'}
        </DialogContentText>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Ficar aberta por</Typography>
        <ToggleButtonGroup exclusive fullWidth color="primary" value={horas} onChange={(e, v) => v && setHoras(v)}>
          {[2, 6, 12, 24].map((h) => <ToggleButton key={h} value={h}>{h}h</ToggleButton>)}
        </ToggleButtonGroup>
        {erro && <Alert severity="error" sx={{ mt: 2 }}>{erro}</Alert>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">Cancelar</Button>
        <Button onClick={abrir} variant="contained" disabled={enviando}>{reabrir ? 'Reabrir' : 'Abrir avaliação'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AbrirAvaliacaoDialog;
